import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const transporterProductSlice = createSlice({
  name: "transporterProduct",

  initialState: {
    transporterProductData: [],
    isError: false,
  },

  reducers: {
    fetchTransporterProductSuccess: (state, action) => {
      state.isError = false;
      state.transporterProductData = action.payload;
    },
    fetchTransporterProductFailure: (state) => {
      state.isError = true;
    },
    resetTransporterProduct: (state) => {
      state.isError = false;
      state.transporterProductData = [];
    },
  },
});

export const {
  fetchTransporterProductSuccess,
  fetchTransporterProductFailure,
  resetTransporterProduct,
} = transporterProductSlice.actions;

export const fetchTransporterProduct = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${config.apiUrl}/transporter/product-enquiry`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      }
    );
    
    dispatch(fetchTransporterProductSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchTransporterProductFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default transporterProductSlice.reducer;
